export function generatePectoralisShape(location_pecto_top, location_pecto_bottom, imgSize, isRightSide) {
    // Convert normalized coordinates to pixel coordinates
    const topX = location_pecto_top[0] * imgSize[0];
    const topY = location_pecto_top[1] * imgSize[1];
    const bottomX = location_pecto_bottom[0] * imgSize[0];
    const bottomY = location_pecto_bottom[1] * imgSize[1];

    // Determine corner based on side
    const cornerX = isRightSide ? imgSize[0] : 0; // Right edge for rmlo, left edge for lmlo
    const cornerY = 0; // Top edge

    // Create triangle: corner -> top -> bottom -> corner
    // Or quadrilateral: corner -> top -> bottom -> bottom corner -> corner
    const shapePoints = [
        [cornerX, cornerY],           // Top corner
        [topX, topY],                 // Pectoralis top point
        [bottomX, bottomY],           // Pectoralis bottom point
        [cornerX, imgSize[1]],        // Bottom corner (extend to bottom)
        [cornerX, cornerY]            // Close the shape
    ];

    return shapePoints;
}

export function drawPectoralisShapeOnCanvas(canvasRef, shapePoints, color) {
    const context = canvasRef.current.getContext('2d');
    context.fillStyle = color;
    context.beginPath();

    // Move to first point
    context.moveTo(shapePoints[0][0], shapePoints[0][1]);

    // Draw lines to each point
    for (let i = 1; i < shapePoints.length; i++) {
        context.lineTo(shapePoints[i][0], shapePoints[i][1]);
    }

    context.closePath();
    context.fill();

    // Convert to imageDataUrl and save
    const imageDataUrl = canvasRef.current.toDataURL('image/png');
    return imageDataUrl;
}
